import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { classes } from "../../constants";
import { fetchTest, registerStudent } from "../../api/utils";
import LoginForm from "../components/loginForm";

const Registration = () => {
  const { test_id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [testData, setTestData] = useState(null);
  const [showLogin, setShowLogin] = useState(false);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "bg-success",
  });

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    studentClass: "",
    school: "",
    countryCode: "+966",
    mobile: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "mobile") {
      const numericValue = value.replace(/\D/g, "");
  
      // Determine max length based on country code
      const maxLength = formData.countryCode === "+91" ? 10 : 9;
  
      if (numericValue.length <= maxLength) {
        setFormData((prev) => ({ ...prev, mobile: numericValue }));
      }
    } else if (name === "countryCode") {
      setFormData((prev) => ({ ...prev, countryCode: value, mobile: "" }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  

  const showToast = (message, bg = "bg-success") => {
    setToast({ show: true, message, bg });
    setTimeout(() => {
      setToast((prev) => ({ ...prev, show: false }));
    }, 3000);
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const testList = await fetchTest(test_id);
      if (testList.status) {
        setTestData(testList.data);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async () => {
    const { name, email, studentClass, school, mobile, countryCode } = formData;

    if (!name || !email || !studentClass || !school || !mobile) {
      showToast("Please fill in all fields before registering.", "bg-danger");
      return;
    }

    // Validate mobile length
    const expectedLength = countryCode === "+966" ? 9 : 10;
    if (mobile.length !== expectedLength) {
      showToast(
        `Mobile number must be ${expectedLength} digits for ${countryCode}`,
        "bg-danger"
      );
      return;
    }

    try {
      const payload = {
        ...formData,
        test_id,
        mobile: countryCode + mobile, // full number with country code
        class: parseInt(studentClass),
      };

      const response = await registerStudent(payload);

      if (response.status === true) {
        showToast(response.message, "bg-success");
        setFormData({
          name: "",
          email: "",
          studentClass: "",
          school: "",
          countryCode: "+966",
          mobile: "",
        });
      } else {
        showToast(
          response?.message || "Registration failed. Try again.",
          "bg-danger"
        );
      }
    } catch (error) {
      showToast(
        error.response?.data?.message || "Registration failed. Try again.",
        "bg-danger"
      );
      console.log(error);
    }
  };

  if (isLoading)
    return (
      <div className="text-center +968">
68     <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );

  return (
    <div className="course-container-home container my-5">
      <div className="row row-cols-1 row-cols-md-3 g-5">
        {/* LEFT SIDE DETAILS */}
        <div className="col-md-6 text-center text-md-start px-5">
          <h1 className="fw-bold text-grey">
            Registration For <br />
            <span className="text-warning">{testData?.name}</span>
          </h1>

          <p className="mt-4 text-grey">{testData?.description}</p>

          <p className="mt-4">
            <strong className="fw-bold text-grey">
              Registration Starting From:
            </strong>{" "}
            {testData?.registration_start_date
              ? new Date(testData.registration_start_date).toLocaleDateString()
              : ""}
          </p>

          <p>
            <strong className="fw-bold text-grey">Eligible Classes:</strong>{" "}
            {testData?.classes_enabled?.join(", ")}
          </p>

          <p>
            <strong className="fw-bold text-grey">Difficulty:</strong>{" "}
            {testData?.difficulty}
          </p>
        </div>

        {/* FORM SECTION */}
        <div className="col-md-6 d-flex justify-content-center">
          <div
            className="card p-4 rounded-4 shadow"
            style={{ maxWidth: "500px", width: "100%" }}
          >
            {!showLogin ? (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <div className="mb-3">
                  <label className="form-label fw-semibold">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Full Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">E-mail</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter E-mail ID"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">Class</label>
                    <select
                      className="form-select"
                      name="studentClass"
                      value={formData.studentClass}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select</option>
                      {classes.map((cls) => (
                        <option key={cls} value={cls}>
                          {cls}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label fw-semibold">School</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter School Name"
                      name="school"
                      value={formData.school}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                {/* MOBILE INPUT WITH COUNTRY CODE */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">Mobile No.</label>
                  <div className="d-flex">
                    <select
                      className="form-select me-2"
                      name="countryCode"
                      value={formData.countryCode}
                      onChange={handleChange}
                      style={{ flex: "0 0 25%" }}
                    >
                      <option value="+91">+91</option>
                      <option value="+966">+966</option>
                      <option value="+971">+971</option>
                      <option value="+965">+965</option>
                      <option value="+973">+973</option>
                      <option value="+974">+974</option>
                      <option value="+968">+968</option>
                    </select>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Mobile Number"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                      style={{ flex: "1" }}
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="primary-button btn-lg btn btn-primary w-100 rounded-pill mt-2"
                >
                  Submit
                </button>
                <p className="text-center mt-3">
                  Already Registered with Us?{" "}
                  <span
                    className="text-primary fw-semibold"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowLogin(true)}
                  >
                    Please Login
                  </span>
                </p>
              </form>
            ) : (
              <div className="w-100">
                <LoginForm test_id={test_id} className="w-100" />

                <p className="text-center mt-3">
                  New User?{" "}
                  <span
                    className="text-primary fw-semibold"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowLogin(false)}
                  >
                    Register Here
                  </span>
                </p>
              </div>
            )}
          </div>
        </div>

        {/* CUSTOM TOAST */}
        {toast.show && (
          <div
            className={`toast align-items-center text-white position-fixed top-0 end-0 m-3 show ${toast.bg}`}
            role="alert"
            style={{ zIndex: 9999 }}
          >
            <div className="d-flex">
              <div className="toast-body">{toast.message}</div>
              <button
                type="button"
                className="btn-close btn-close-white me-2 m-auto"
                onClick={() => setToast({ ...toast, show: false })}
              ></button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Registration;
